<template>
  <vue-timepicker
      id="timeselection"
      hide-clear-button
      placeholder="Select Time"
      hour-label="hour"
      minute-label="minute"
      minute-interval="5"
      v-model="selectedTime"
      format="hh:mm A"
    ></vue-timepicker>
</template>

<script>

import 'vue2-timepicker/dist/VueTimepicker.css'
import VueTimepicker from 'vue2-timepicker'

export default {
  data() {
    return {
      selectedTime: null,
    }
  },
  watch: {
    selectedTime(val) {
      this.$emit('input', val)
    },
  },
   components: {
    VueTimepicker,
  },
}
</script>

<style >
.vue__time-picker input.display-time {
  padding-left: 10px !important;
  background: white !important;
  border: 1px solid black !important;
  width: 200px !important;;
  height: 40px !important;;
  border-radius: 4px !important;;
}
</style>
